/**
 * The single place the layout hands a step config to the AI widget.
 *
 * The widget treats every `ai-content` write as a new host event. Writing the
 * same visit twice (a template binding plus an imperative write, or a change
 * detection pass re-serializing it) restarted the step flow mid-sentence.
 */

/**
 * Write `aiContent` to the element unless it already carries exactly this
 * value. Returns whether a write happened.
 */
export function writeAiContent(element: Element, aiContent: Record<string, unknown>): boolean {
  const json = JSON.stringify(aiContent);
  if (element.getAttribute('ai-content') === json) return false;
  element.setAttribute('ai-content', json);
  return true;
}

/** What may be logged about a config: shape, never values that identify anyone. */
export function summarizeAiContent(aiContent: Record<string, unknown>): Record<string, unknown> {
  const content = typeof aiContent['content'] === 'string' ? (aiContent['content'] as string) : '';
  return {
    agentId: aiContent['agentId'],
    flowSeq: aiContent['flowSeq'],
    muteAi: aiContent['muteAi'],
    autoStart: aiContent['autoStart'],
    hasContent: content.length > 0,
    contentLength: content.length,
    hasAuthToken: !!aiContent['authToken'],
    hasStudentId: !!aiContent['studentId'],
    hasStudentCourseId: !!aiContent['studentCourseId'],
  };
}
